import { ABTestRecordGroup, AbTestRequest, AbTestResponse, PreGenerateAbTestRequest } from 'types/ab-test';
import { apiRequest, constructUrlWithQueryParams } from '@utils/request';
import { getDistinctId, trackMixpanel, trackMixpanelWithCallback } from '@utils/analytics';
import { getItemFromSessionStorage, setItemInSessionStorage } from '@utils/web-storage';

export async function saveAbTestGroup(abTestGroup: ABTestRecordGroup): Promise<void> {
	await apiRequest.post(`/ab-test/record`, abTestGroup);
}

function getStorageKey(testName: string, mixpanelId: string): string {
	return testName + mixpanelId;
}

export async function getAbTestGroup(testName: string): Promise<string | undefined> {
	const mixpanelId = getDistinctId();

	try {
		if (mixpanelId) {
			const localStorageValue = getItemFromSessionStorage(getStorageKey(testName, mixpanelId));
			if (localStorageValue) {
				return localStorageValue;
			}

			const abTestRequest: AbTestRequest = {
				mixpanelId: mixpanelId,
				clientId: window.fundriseApp.apiClientId,
				testName: testName
			};
			const reponse = await apiRequest.get(constructUrlWithQueryParams('/ab-test', abTestRequest));
			const reponseData: AbTestResponse = reponse.data;

			if (reponseData.active) {
				setItemInSessionStorage(getStorageKey(testName, mixpanelId), reponseData.group);

				trackMixpanel('Web AB Test', {
					Group: reponseData.group,
					'Test Name': reponseData.testName,
					'Initial Enrollment': reponseData.initialEnrollment
				});
			}

			return reponseData.group;
		} else {
			const preGenRequest: PreGenerateAbTestRequest = {
				testName: testName
			};
			const response = await apiRequest.get(constructUrlWithQueryParams('/ab-test/pre-generate', preGenRequest));
			const reponseData: AbTestResponse = response.data;

			if (reponseData.active) {
				const mixpanelCallback = function () {
					const distinctid = getDistinctId();
					if (distinctid !== undefined) {
						const abTestGroup: ABTestRecordGroup = {
							mixpanelId: distinctid,
							clientId: window.fundriseApp.apiClientId,
							testGroup: reponseData.group,
							testName: reponseData.testName
						};

						setItemInSessionStorage(getStorageKey(testName, distinctid), reponseData.group);
						saveAbTestGroup(abTestGroup);
					}
				};

				trackMixpanelWithCallback(
					'Web AB Test',
					{
						Group: reponseData.group,
						'Test Name': reponseData.testName,
						'Initial Enrollment': reponseData.initialEnrollment,
						pregenerated: true
					},
					mixpanelCallback
				);
			}

			return reponseData.group;
		}
	} catch (e) {
		return undefined;
	}
}
